import { SidePanelConfigDefaultIdentifiers } from 'src/app/shared/components/side-panel/side-panel.model';

export enum ActionButtonColor {
    Primary = 'primary',
    Secondary = 'secondary',
    Accent = 'accent',
    Warn = 'warn'
}

export interface ActionButtonConfig {
    identifier?: any;
    text: string;
    color: ActionButtonColor;
    clickResult?: any;
    class?: string;
    type?: ActionButtonType;
    style?: string;
    isDisabled?: boolean;
    isCloseButton?: boolean;
}

export enum ActionButtonType {
    MatButton = 'mat-button',
    MatRaisedButton = 'mat-raised-button',
    MatFlatButton = 'mat-flat-button',
    MatStroked = 'mat-stroked-button'
}

export const initActionButtonDefaultConfigs = (): ActionButtonConfig[] => {
    return [
        {
            text: 'Save',
            identifier: SidePanelConfigDefaultIdentifiers.Save,
            color: ActionButtonColor.Secondary,
            clickResult: true,
            class: '',
            type: ActionButtonType.MatRaisedButton,
            style: 'width: 138px',
            isDisabled: false,
            isCloseButton: false
        },
        {
            text: 'Cancel',
            identifier: SidePanelConfigDefaultIdentifiers.Cancel,
            color: ActionButtonColor.Primary,
            clickResult: false,
            class: 'cancel-button',
            type: ActionButtonType.MatButton,
            style: 'text-decoration: underline',
            isDisabled: false,
            isCloseButton: true
        }
    ];
};
